(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TkbPaymentController', TkbPaymentController);

    TkbPaymentController.$inject = ['$state', '$window', '$http', '$uibModal', 'DateUtils', 'TkbPayment', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'ProfileIdByPhone'];

    function TkbPaymentController($state, $window, $http, $uibModal, DateUtils, TkbPayment, ParseLinks, AlertService, paginationConstants, pagingParams, ProfileIdByPhone) {

        var vm = this;
        vm.tkbPayments = [];
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.openProfile = openProfile;
        vm.search = search;
        vm.excel = excel;
        vm.clear = clear;
        vm.getPaymentState = getPaymentState;
        vm.confirmPayment = confirmPayment;
        vm.recreditPayment = recreditPayment;
        vm.openPaymentInfo = openPaymentInfo;
        vm.initPopover = initPopover;
        vm.initCreditPopover = initCreditPopover;
        vm.checkList = [];
        vm.searchQuery = {
            userPhone: pagingParams.userPhone,
            externalId: pagingParams.externalId,
            account: pagingParams.account,
            state: pagingParams.state,
            creditState: pagingParams.creditState,
            gateway: pagingParams.gateway,
            transactionStatus: pagingParams.transactionStatus,
            fromDate: pagingParams.fromDate,
            toDate: pagingParams.toDate,
            from: pagingParams.from,
            to: pagingParams.to
        };

        initDatePicker();
        loadAll();

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus.from = false;
        vm.datePickerOpenStatus.to = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function initDatePicker() {
            if (vm.searchQuery.toDate === null) {
                vm.searchQuery.to = new Date();
                pagingParams.toDate = vm.searchQuery.to;
            }
            if (vm.searchQuery.fromDate === null) {
                vm.searchQuery.from = new Date();
                vm.searchQuery.from.setMonth(vm.searchQuery.from.getMonth() - 1);
                pagingParams.fromDate = vm.searchQuery.from;
            }
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'from') {
                    $(this).val(vm.searchQuery.from);
                } else if ($(this).attr('name') == 'to') {
                    $(this).val(vm.searchQuery.to);
                }
            });

            $('.date-picker').datepicker({autoclose: true});
        }

        function getDateTimeFromPicker() {
            $('.input-daterange input').each(function () {
                if ($(this).attr('name') == 'from') {
                    vm.searchQuery.fromDate = $(this).val();
                } else if ($(this).attr('name') == 'to') {
                    vm.searchQuery.toDate = $(this).val();
                }
            });
        }

        function loadAll() {
            getDateTimeFromPicker();
            TkbPayment.query({
                userPhone: vm.searchQuery.userPhone,
                externalId: vm.searchQuery.externalId,
                account: vm.searchQuery.account,
                state: vm.searchQuery.state,
                creditState: vm.searchQuery.creditState,
                gateway: vm.searchQuery.gateway,
                transactionStatus: vm.searchQuery.transactionStatus,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate,
                from: vm.searchQuery.from,
                to: vm.searchQuery.to,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tkbPayments = data;
                vm.tkbPayments.forEach(function (payment) {
                    if (payment.fieldJson) {
                        var parsed = JSON.parse(payment.fieldJson);
                        payment.description = parsed.description;
                    }
                });
                vm.page = pagingParams.page;
                setTimeout(function () {
                    enableClipboard();
                }, 0);
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                userPhone: vm.searchQuery.userPhone,
                externalId: vm.searchQuery.externalId,
                account: vm.searchQuery.account,
                state: vm.searchQuery.state,
                creditState: vm.searchQuery.creditState,
                gateway: vm.searchQuery.gateway,
                transactionStatus: vm.searchQuery.transactionStatus,
                fromDate: vm.searchQuery.fromDate,
                toDate: vm.searchQuery.toDate,
                from: vm.searchQuery.from,
                to: vm.searchQuery.to
            });
        }

        function search() {
            getDateTimeFromPicker();
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.searchQuery = {
                userPhone: null,
                externalId: null,
                account: null,
                state: null,
                creditState: null,
                gateway: 'ALL',
                transactionStatus: "UNKNOWN",
                fromDate: null,
                toDate: null,
                from: null,
                to: null
            };
            initDatePicker();
            vm.transition();
        }

        function excel() {
            getDateTimeFromPicker();
            var fromDate = vm.searchQuery.fromDate === "" ? null : DateUtils.converterDateTimeFormat(vm.searchQuery.fromDate);
            var toDate = vm.searchQuery.toDate === "" ? null : DateUtils.converterDateTimeFormat(vm.searchQuery.toDate);
            var data = (vm.searchQuery.userPhone == null ? "" : "userPhone=" + vm.searchQuery.userPhone)
                + (vm.searchQuery.externalId == null ? '' : "&externalId=" + vm.searchQuery.externalId)
                + (vm.searchQuery.account == null ? '' : "&account=" + vm.searchQuery.account)
                + (vm.searchQuery.state == null ? '' : "&state=" + vm.searchQuery.state)
                + (vm.searchQuery.creditState == null ? '' : "&creditState=" + vm.searchQuery.creditState)
                + (vm.searchQuery.gateway == null ? 'ALL' : "&gateway=" + vm.searchQuery.gateway)
                + (vm.searchQuery.transactionStatus == null ? 'UNKNOWN' : "&transactionStatus=" + vm.searchQuery.transactionStatus)
                + "&fromDate=" + fromDate
                + '&toDate=' + toDate;
            $http({
                url: 'api/tkb-payments-excel',
                method: 'POST',
                responseType: 'arraybuffer',
                data: data,
                headers: {
                    'Content-type': 'application/x-www-form-urlencoded'
                }
            }).success(function (data) {
                var blob = new Blob([data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });

                saveAs(blob, 'tkb-payments-' + DateUtils.currentTimestamp() + '.xlsx');
            }).error(function () {
            });

        }

        function openProfile(phoneNumber) {
            ProfileIdByPhone.get({phoneNumber: phoneNumber}, onSuccess);

            function onSuccess(data) {
                var url = $state.href('profile-detail', {id: data.profileId});
                $window.open(url,'_blank');
            }
        }

        function getPaymentState(externalId) {
            vm.checkList[externalId] = true;
            TkbPayment.getPaymentState({externalId: externalId}, onSuccess, onError);

            function onSuccess() {
                vm.checkList[externalId] = false;
                vm.externalId = null;
                loadAll();
            }

            function onError(error) {
                vm.checkList[externalId] = false;
                AlertService.error(error.data.message);
            }
        }

        function confirmPayment(externalId) {
            vm.checkList[externalId] = true;
            TkbPayment.confirmPayment({externalId: externalId}, onSuccess, onError);

            function onSuccess() {
                vm.checkList[externalId] = false;
                vm.externalId = null;
                loadAll();
            }

            function onError(error) {
                vm.checkList[externalId] = false;
                AlertService.error(error.data.message);
            }
        }

        function recreditPayment(orderId) {
            vm.checkList[orderId] = true;
            TkbPayment.recreditPayment({orderId: orderId}, onSuccess, onError);

            function onSuccess() {
                vm.checkList[orderId] = false;
                vm.orderId = null;
                loadAll();
            }

            function onError(error) {
                vm.checkList[orderId] = false;
                AlertService.error(error.data.message);
            }
        }

        function enableClipboard() {
            var clipboardClass = document.getElementsByClassName('mt-clipboard');
            var clipboard = new Clipboard(clipboardClass);
        }

        function initPopover($event, payment) {
            if (!payment.errorMessage) {
                return;
            }
            var errorMessage = payment.errorMessage;
            var elementId = payment.id;

            var popoverContent =
                '<div style="display: flex" id="popover-text">' +
                '<a id="copy-btn" style="padding: 5px 5px; font-size: 12px;"> ' + errorMessage + '</a>' +
                '</div>';

            angular.element('#' + elementId).popover({
                html: true,
                content: popoverContent,
                trigger: 'manual'
            }).popover('toggle');

            angular.element('[data-toggle="popover"]').not('#' + elementId).popover('hide');

            setTimeout(function () {
                var copyBtn = document.getElementById('copy-btn');
                if (copyBtn) {
                    copyBtn.addEventListener('click', function () {
                        copyPopoverText();
                    });
                }
            }, 100);

            angular.element(document).on('mousedown.popoverClose', function (e) {
                if (!angular.element(e.target).closest('.popover').length && !angular.element(e.target).is('#' + elementId)) {
                    angular.element('#' + elementId).popover('hide');
                    angular.element(document).off('mousedown.popoverClose');
                }
            });
        }

        function initCreditPopover($event, payment) {
            if (!payment.creditDescription) {
                return;
            }
            var creditMessage = payment.creditDescription;
            var elementId = payment.id + '-credit';

            var popoverContent =
                '<div style="display: flex" id="popover-text">' +
                '<a id="copy-btn" style="padding: 5px 5px; font-size: 12px;"> ' + creditMessage + '</a>' +
                '</div>';

            angular.element('#' + elementId).popover({
                html: true,
                content: popoverContent,
                trigger: 'manual'
            }).popover('toggle');

            angular.element('[data-toggle="popover"]').not('#' + elementId).popover('hide');

            setTimeout(function () {
                var copyBtn = document.getElementById('copy-btn');
                if (copyBtn) {
                    copyBtn.addEventListener('click', function () {
                        copyPopoverText();
                    });
                }
            }, 100);

            angular.element(document).on('mousedown.popoverClose', function (e) {
                if (!angular.element(e.target).closest('.popover').length && !angular.element(e.target).is('#' + elementId)) {
                    angular.element('#' + elementId).popover('hide');
                    angular.element(document).off('mousedown.popoverClose');
                }
            });
        }

        function copyPopoverText() {
            var textElement = document.getElementById('popover-text');
            if (!textElement) return;

            var textArea = document.createElement('textarea');
            textArea.value = textElement.innerText;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
        }

        function openPaymentInfo(id) {
            $uibModal.open({
                templateUrl: 'app/entities/tkb-payment/tkb-payment-info-dialog.html',
                controller: 'TkbPaymentInfoDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass: 'tkb-payment-info-dialog-xl',
                resolve: {
                    entity: ['TkbPayment', function(TkbPayment) {
                        return TkbPayment.paymentInfo({ paymentId: id }).$promise;
                    }]
                }
            });
        }
    }
})();
